import script from "./delete-requisition-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./delete-requisition-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__